export default {
  isHere: false,
  collabRouters: []
}
